import axios from 'axios'
import axiosInstance from '../axios'
import { rejectError } from '../helper'

export default {
  state: {
    token: null,
    username: null,
    user: null,
    superadmin: 0,
  },
  mutations: {
    setToken (state, token) {
      state.token = token
    },
    setUsername (state, username) {
      state.username = username
    },
    storeUser (state, user) {
      state.user = user
    },
    setSuperadmin (state, val) {
      state.superadmin = val
    },
    clearAuthData (state) {
      state.token = null
      state.username = null
      state.user = null
      state.superadmin = 0
    },
  },
  getters: {
    user (state) {
      return state.user
    },
    isAuthenticated (state) {
      return state.token !== null
    },
    isSuperadmin (state) {
      return state.superadmin
    },
    getUsername (state) {
      return state.username
    },
  },
  actions: {
    // eslint-disable-next-line no-unused-vars
    login ({ commit }, token) {
      const params = {
        $limit: 2,
      }
      const headers = {
        'X-Access-Token': token,
      }
      return axios.get('/api/v1/users', {
        params,
        headers,
      })
        .then((result) => {
          const res = result.data.data || []

          if (res.length === 2) {
            localStorage.setItem('super', 1)
            commit('setSuperadmin', 1)
          } else {
            commit('setSuperadmin, 0')
          }
          localStorage.setItem('token', token)
          return commit('setToken', token)
        })
        .catch((error) => {
          commit('clearAuthData')
          localStorage.removeItem('token')
          return rejectError(error)
        })
    },
    // eslint-disable-next-line no-unused-vars
    tryAutoLogin ({ commit, state, dispatch }) {
      const token = localStorage.getItem('token')
      if (!token) {
        return false
      }
      return dispatch('login', token)
    },
    fetchUser ({ commit, state }) {
    },
    // eslint-disable-next-line no-unused-vars
    logout ({ commit }) {
      commit('clearAuthData')
      localStorage.removeItem('token')
    },
  },
}
